export default "__VITE_ASSET__sS9Aaijs__"